import { buildingBlocked } from '@onark/shared/billing';

/**
 * When a mutation was refused by the "plan ended" wall, tell the admin why and
 * offer the billing page. Returns false for any other error so the caller keeps
 * its own handling (usually rethrowing to Rollbar).
 */
// ponytail: native confirm(), swap for an inline flash like PublishBtn's if the copy needs styling.
export function offerPlanIfWalled(
  err: unknown,
  push: (href: string) => unknown
): boolean {
  const wall = buildingBlocked(err instanceof Error ? err.message : '');

  if (!wall) return false;
  if (window.confirm(`${wall.message}\n\nGo to billing now?`)) {
    void push(wall.href);
  }

  return true;
}
